import { MailApi } from '@quadminds/client-apis/mail';

// Get the mail API URL from environment variables
const MAIL_API_URL = process.env['NX_MAIL_API_URL'];

if (!MAIL_API_URL) {
    throw new Error('NX_MAIL_API_URL environment variable is required but not set');
}

// Default template ID for feedback emails
const FEEDBACK_TEMPLATE_ID = 'd-c4865d97cc3d49fe97b891b222e1b507';

// Create the mail API instance with the configured URL
export const mailApi = new MailApi({
    baseURL: MAIL_API_URL,
    withCredentials: false,
    debug: true,
    defaultTemplateId: FEEDBACK_TEMPLATE_ID,
});
